import { LoadingContainer, Select, Modal, Model } from 'peach/components'
import { useClickAction } from 'peach/decorators/withActionTrigger'
import { useParams } from 'peach/router'

import { Page } from 'core/components'
import { R, isForbiddenError, isNotFoundError } from 'core/helpers'
import {
  useGetPersonDocument,
  useUpdatePersonDocument,
  useDownloadPersonDocumentContent,
} from 'core/types'

const Document = () => {
  const { personId, documentId } = useParams()

  const {
    data: doc,
    isLoading,
    error,
  } = useGetPersonDocument({
    personId,
    documentDescriptorId: documentId,
  })

  const { mutateAsync: updateDocument } = useUpdatePersonDocument({
    personId,
    documentDescriptorId: documentId,
  })

  const { data: documentContent } = useDownloadPersonDocumentContent({
    personId,
    documentDescriptorId: documentId,
    options: {
      throwOnError: R.isNot(isNotFoundError) && R.isNot(isForbiddenError),
    },
  })

  const openDocument = ({ action }) => {
    const { url } = documentContent ?? {}

    if (action === 'download') window.location.href = url

    if (action === 'view') window.open(url, '_blank', 'fullscreen=yes')

    return url
  }

  useClickAction({
    label: 'Download Document',
    onClick: () => openDocument({ action: 'download' }),
  })

  useClickAction({
    label: 'View Document',
    onClick: () => openDocument({ action: 'view' }),
  })

  return (
    <LoadingContainer error={error} loading={isLoading}>
      <Modal
        initialValue={doc}
        onSubmit={async (_doc, diff) => {
          await updateDocument(diff)
        }}
        title='Edit Document'
      >
        <Select boolean formKey='archived' />
      </Modal>
      <Page variant='full'>
        <Model.Viewer json={doc} title='Document' />
      </Page>
    </LoadingContainer>
  )
}

export default Document
